'use client'

import { useAuth } from '@/lib/contexts/auth-context'
import { useEffect, useState } from 'react'

export function useRole(role: string | string[]): boolean {
  const { hasRole, hasAnyRole, isLoading } = useAuth()
  const [hasAccess, setHasAccess] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      if (Array.isArray(role)) {
        setHasAccess(hasAnyRole(role))
      } else {
        setHasAccess(hasRole(role))
      }
    }
  }, [role, hasRole, hasAnyRole, isLoading])

  return hasAccess
}

export function useRequireRole(
  role: string | string[],
  redirectTo: string = '/unauthorized'
): boolean {
  const hasAccess = useRole(role)
  const { isLoading } = useAuth()
  
  useEffect(() => {
    if (!isLoading && !hasAccess) {
      window.location.href = redirectTo
    }
  }, [hasAccess, isLoading, redirectTo])

  return hasAccess
}